export const titleCase = (s: string) =>
  s
    .replace(/^[-_]*(.)/, (_, c) => c.toUpperCase()) // Initial char (after -/_)
    .replace(/[-_]+(.)/g, (_, c) => ' ' + c.toUpperCase());

export const separateNumberWithCommas = (value: string | number) => {
  return Number(`${value}`!.split(',').join('')).toLocaleString('en-US');
};
